import GridFactory from './grid'
import HexFactory from './hex'
import { ORIENTATIONS } from './hex/constants'
import Point from './point'
import Views from './views'

const Grid = GridFactory({ HexFactory })

export {
    ORIENTATIONS as HEX_ORIENTATIONS,
    Grid,
    Point,
    Views,
    HexFactory
}



//////////////////
// WEBPACK FOOTER
// ./~/honeycomb-grid/src/honeycomb.js
// module id = 8
// module chunks = 0